module.exports = __webpack_public_path__ + "img/cooking.8c0fef74.svg";